export default __webpack_public_path__ + "static/media/red-circle.a46c01f4.svg";